import { render, staticRenderFns } from "./TokenInput.vue?vue&type=template&id=daf8d408&scoped=true&"
import script from "./TokenInput.vue?vue&type=script&lang=js&"
export * from "./TokenInput.vue?vue&type=script&lang=js&"
import style0 from "./TokenInput.vue?vue&type=style&index=0&id=daf8d408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf8d408",
  null
  
)

export default component.exports